import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class AirportAssignFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  onChangeDate(date) {
    const [startDate, endDate] = Array.isArray(date) ? date : [null, null];

    const formattedStart = startDate ? startDate.format("MMMM D, YYYY") : "";
    const formattedEnd = endDate ? endDate.format("MMMM D, YYYY") : "";

    const dateRange =
      formattedStart && formattedEnd
        ? `${formattedStart} - ${formattedEnd}`
        : "";

    this.view.setState((prevState) => ({
      object: {
        ...prevState.object,
        date: dateRange,
      },
    }));
  }

  // async save() {
  //   const collection = this.view.getCollectionName();
  //   if (this.object.id) {
  //     this.change.id = this.object.id;
  //   } else {
  //     this.change.acl = this.view.getAcl();
  //   }
  //   try {
  //     const name = this.view.setStateScheduleName();
  //     this.change.name = name;
  //     await this.upsertUseCase.execute(collection, this.change);
  //     this.change = {};
  //   } catch (error) {
  //     throw error; // rethrow the error to be caught by the caller
  //   }
  // }
}

export default AirportAssignFormPresenter;
